export default function contains(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-dialog/node_modules/rc-util/es/Dom/contains.js
// module id = 921
// module chunks = 0